import React from "react";
import {Container} from "semantic-ui-react";
import ReferenceList from "../../../components/torres/reference-components/reference-list";

const ReferencePage = () => {

    return (
        <Container fluid style={{ padding: "20px" }}>
    <ReferenceList />
</Container>
    );
};

export default ReferencePage;
